<div id="radio-button-component">
  <mat-radio-group
    aria-labelledby="radio-group"
    class="tw-flex tw-flex-col gap-[10px]"
    [formControl]="selectedBusinessType"
  >
    @for (businessType of businessTypes; track businessType) {
    <mat-radio-button class="radio-button" [value]="businessType.value">
      <p class="tw-text-white">{{ getBusinessLabel(businessType.value) }}</p>
      <div *ngIf="selectedBusinessType.value === businessType.value">
        <p
          *ngIf="getRequirements(businessType.value).length > 0"
          class="tw-text-white tw-text-[10.25px]"
        >
          {{ "advanced-pages.radio-button.requirements" | i18next }}
        </p>
        <ol class="tw-list-decimal tw-ml-4">
          <li
            class="tw-text-white tw-text-[10.25px]"
            *ngFor="let requirement of getRequirements(businessType.value)"
          >
            {{ requirement }}
            <div *ngIf="requirement === 'At least one of the following:'">
              <p>- Income tax return</p>
              <p>- Latest Audited Financial Statements</p>
              <p>- Philippine Council for NGO Certification</p>
              <p>- SEC Mandatory Disclosure Form</p>
            </div>
          </li>
        </ol>
      </div>
    </mat-radio-button>
    }
  </mat-radio-group>
</div>
